<style type="text/css">
  [data-aos] {
    opacity: 1 !important;
    transform: translate(0) scale(1) !important;
  }
</style>

<body id="top">

  <h5 align="center" style="margin-top: 2%;">Below you will find the certificates that I've seen to be the most
    important ones</h5>




  <ngb-carousel class="text-lg-center">
    <ng-template ngbSlide *ngFor="let certificate of certificates; index as i" >
      <div class="picsum-img-wrapper text-center">
        
        <img src="{{certificate.src}}" alt="{{certificate.name}} certificate"
          style="max-width: 75%!important; height: autopx!important; object-fit: contain;">
      </div>
    </ng-template>


  </ngb-carousel>

  <p style="padding-top:20px" align="center">Within the table below you will find a <u>link</u> [if exists] to check the
    certificate credentials <span style="font-size: 10pt;"><i>more is coming soon</i></span></p>

  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Certificate</th>
        <th scope="col">Provider</th>
        <th scope="col">Link</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let certificate of certificates; index as i">
        <th scope="row">{{ i + 1 }}</th>
        <td style="word-wrap: normal;">

          {{ certificate.name }}
        </td>
        <td><b>{{ certificate.provider}}</b></td>


        <td *ngIf='certificate.link; then existsBlock; else elseBlock'> </td>

        <ng-template #existsBlock>
          <td><a target="_blank" href="{{certificate.link}}"><img src="/assets/images/link.svg" ></a></td>
        </ng-template>
        <ng-template #elseBlock>
          <td>No link</td>
        </ng-template>
      </tr>
    </tbody>
  </table>

  <script src="/assets/2nd/scripts/bootstrap.bundle.min.js?ver=1.2.0"></script>
  <script src="/assets/2nd/scripts/aos.js?ver=1.2.0"></script>
  <script src="/assets/2nd/scripts/main.js?ver=1.2.0"></script>
  <script src="/assets/scripts/imagesloaded.pkgd.min.js?ver=1.1.0"></script>
  <script src="/assets/scripts/masonry.pkgd.min.js?ver=1.1.0"></script>
  <script src="/assets/scripts/bootstrap.bundle.min.js?ver=1.1.0"></script>
  <script src="/assets/scripts/aos.js?ver=1.1.0"></script>
  <script src="/assets/scripts/main.js?ver=1.1.0"></script>
  <script src="https://code.jquery.com/jquery-3.3.1.slim.min.js"
    integrity="sha384-q8i/X+965DzO0rT7abK41JStQIAqVgRVzpbzo5smXKp4YfRvH+8abtTE1Pi6jizo"
    crossorigin="anonymous"></script>

</body>